/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_CreatedInputs */

const en_case_history_verb_task_created = /** @type {(inputs: Case_History_Verb_Task_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`created`)
};

const pt_br2_case_history_verb_task_created = /** @type {(inputs: Case_History_Verb_Task_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`criada`)
};

/**
* | output |
* | --- |
* | "created" |
*
* @param {Case_History_Verb_Task_CreatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_created = /** @type {((inputs?: Case_History_Verb_Task_CreatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_CreatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_created(inputs)
	return pt_br2_case_history_verb_task_created(inputs)
});